import React from "react";
import { checkoutActionTypes, CheckoutItemsProps } from "../../../../../store/modules/checkout/types";
import { Botton, MinusIcon } from "../../styles";
import { useCheckoutFunction } from "../../../../../hooks/useCheckoutFunctions";
import { getQuantityIncrement } from "../../../../../utils/getQuantityIncrement";

interface IProductDetail {
  product: CheckoutItemsProps;
  inputValue: string;
  setInputValue?: (value: string) => {}
}

export function QuantitySubtraction({ product, inputValue, setInputValue }: IProductDetail) {
  const { handleCheckoutActions } = useCheckoutFunction();
  const isKg = product.product?.un === 'Kg';
  const increment = getQuantityIncrement(product.product);
  return (
    <>
      {product.product && !product.product.services && (
        <Botton
          id="button-action-decrement"
          onClick={() => {
            // Decrementa de 100g em 100g
            let baseQty =
              inputValue !== ''
                ? parseFloat(inputValue.replace(',', '.'))
                : Number(product.quantity);
            let newQty;
            if (isKg) {
              newQty = Math.max(0, Number((baseQty - increment).toFixed(3)));
              // Arredonda para baixo para múltiplo de 0.1
              newQty = Math.floor(newQty * 10) / 10;
            } else {
              newQty = Math.max(0, Math.floor(baseQty - increment));
            }
            if (newQty === 0) {
              handleCheckoutActions(
                checkoutActionTypes.REMOVE_PLU_CHECKOUT,
                product.product.product_id || '',
                "0"
              );
              //   setInputValue('');
            } else {
              const qtyToSend = isKg
                ? newQty.toFixed(3)
                : String(newQty);
              //   setInputValue(
              //     isKg ? qtyToSend.replace('.', ',') : qtyToSend,
              //   );
              handleCheckoutActions(
                checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                product.product.product_id || '',
                qtyToSend,
                undefined,
                undefined,
              );
            }
          }}
          style={{ background: 'transparent' }}
        >
          <MinusIcon color="red" size={15} />
        </Botton>
      )}
    </>
  )
}